import { useStrapiQuery } from 'hooks/useStrapiQuery';
import type { Pagination } from 'hooks/useTablePagination';
import { JobName } from '@enmon/commons/lib/tools';
import { JobsCardTab } from '../enums/JobsCardTab';
import {
  type AsyncJobListData,
  type AsyncJobsCardVariables,
  GET_ASYNC_JOBS_LIST_DATA,
} from '../queries/getAsyncJobListData';

function getQueryVariablesForTab(activeTab: JobsCardTab) {
  switch (activeTab) {
    case JobsCardTab.MeterActivation:
      return {
        sort: ['createdAt:desc'],
        filter: { name: { eq: JobName.ActivateMeters } },
      };
    case JobsCardTab.MeterDeactivation:
      return {
        sort: ['createdAt:desc'],
        filter: { name: { eq: JobName.DeactivateMeters } },
      };
    case JobsCardTab.PDFPasport:
      return {
        sort: ['createdAt:desc'],
        filter: { name: { eq: JobName.GeneratePasport } },
      };
    case JobsCardTab.ParseDocuments:
      return {
        sort: ['createdAt:desc'],
        filter: { name: { eq: JobName.ParseDocuments } },
      };
    case JobsCardTab.ProcessInvoices:
      return {
        sort: ['createdAt:desc'],
        filter: { name: { eq: JobName.ProcessInvoices } },
      };
    default:
      return {};
  }
}

export const useCardAsyncJobs = (activeJobsTab: JobsCardTab, paginationOptions: Pagination) => {
  const variables: AsyncJobsCardVariables = {
    limit: paginationOptions.pageSize,
    start: (paginationOptions.current - 1) * paginationOptions.pageSize,
    ...getQueryVariablesForTab(activeJobsTab),
  };

  return useStrapiQuery<AsyncJobListData, AsyncJobsCardVariables>(GET_ASYNC_JOBS_LIST_DATA, {
    variables,
  });
};
